import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Pagination } from "../../../../Components/Pagination";

export default function TableContainer({ headers, data, loading }) {
  const { lang } = useSelector((state) => state);
  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 14;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data && data.slice(indexOfFirstData, indexOfLastData);
  const totalPages = data && data.length;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const tongCanXuatBao = data.reduce(
    (sum, i) => sum + (i.PhanPhoiCanXuat?.Bao || 0),
    0
  );

  const tongThucTeBao = data.reduce(
    (sum, i) => sum + (i.PhanPhoiThucTe?.Bao || 0),
    0
  );
  const tongGhiNhanBao = data.reduce(
    (sum, i) => sum + (i.PhanPhoiGhiNhan?.Bao || 0),
    0
  );
  const tong =
    tongThucTeBao > 0
      ? ((tongGhiNhanBao / tongCanXuatBao) * 100).toFixed(2)
      : 0;

  const tileTong = tong < 0.01 ? "0%" : tong + "%";

  return (
    <div
      className="p-1 d-flex flex-column justify-content-between"
      style={{
        height: currentData && currentData.length ? "75vh" : "auto",
        // overflow: "auto",
      }}
    >
      <div
        style={{
          overflow: "auto",
        }}
      >
        <table className="table-custom w-100 mb-3">
          <thead>
            <tr>
              <td rowSpan={2}>#</td>
              {headers.map((header, index) =>
                header.child ? (
                  <td
                    className="align-center"
                    key={index}
                    colSpan={header.child.length}
                    rowSpan={1}
                  >
                    {header.label}
                  </td>
                ) : (
                  <td
                    className="align-center"
                    key={index}
                    rowSpan={header.rowSpan}
                    colSpan={header.colSpan}
                  >
                    {header.label}
                  </td>
                )
              )}
            </tr>

            <tr>
              {headers
                .filter((h) => h.child)
                .map((h, i) =>
                  h.child.map((child, j) => (
                    <td
                      className="align-center"
                      key={`${i}-${j}`}
                      rowSpan={child.rowSpan}
                      colSpan={child.colSpan}
                    >
                      {child.label}
                    </td>
                  ))
                )}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="align-center">
                <td colSpan={headers.length + 10}>
                  <img
                    width={35}
                    className="mb-1"
                    src="/images/icon/load.gif"
                    alt="Loading..."
                  />
                </td>
              </tr>
            ) : currentData && currentData.length ? (
              <>
                {currentData.map((item, rowIndex) => (
                  <tr key={rowIndex} className="align-center">
                    <td>{indexOfFirstData + rowIndex + 1}</td>
                    <td>{item?.MaSP}</td>
                    <td>{item?.TenSP}</td>

                    <td>{item?.PhanPhoiCanXuat?.Bao}</td>
                    <td>{item?.PhanPhoiCanXuat?.Tan}</td>

                    <td>{item?.PhanPhoiThucTe?.Bao}</td>
                    <td>{item?.PhanPhoiThucTe?.Tan}</td>

                    <td>{item?.PhanPhoiGhiNhan?.Bao}</td>
                    <td>{item?.PhanPhoiGhiNhan?.Tan}</td>
                    <td>{item?.DongBaoChenhLech}</td>
                    <td>{item?.TiLe || 0}%</td>
                  </tr>
                ))}
                <tr className="align-center">
                  <td colSpan={3}>Tổng</td>
                  <td>{tongCanXuatBao}</td>
                  <td></td>
                  <td>{tongThucTeBao}</td>
                  <td></td>
                  <td>{tongGhiNhanBao}</td>
                  <td></td>
                  <td>{tongCanXuatBao - tongGhiNhanBao}</td>
                  <td>{tileTong}</td>
                </tr>
              </>
            ) : (
              <tr className="align-center">
                <td className="bold" colSpan={headers.length + 10}>
                  Không tìm thấy thông tin
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {currentData && currentData.length > 0 && (
        <Pagination
          total={totalPages}
          itemsPerPage={dataPerPage}
          currentPage={currentPage}
          paginate={paginate}
          lang={lang}
        />
      )}
    </div>
  );
}
